import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'
import { clsx } from 'clsx'

// Icon-only button primitive — one source for every ≥--tap square icon control
// (TopBar actions, row overflow menus). Requires a `label` so the icon-only
// control is always announced (a11y). Colour inherits (--fg) by default; pass a
// text-color class to override. Consolidated from copies that had drifted across
// five screens — change the affordance here, everywhere follows.
export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string
  children: ReactNode
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, className, type, children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      aria-label={label}
      className={clsx(
        'h-[var(--tap)] w-[var(--tap)] inline-flex items-center justify-center rounded-[var(--radius)]',
        'hover:bg-[var(--line-soft)] active:scale-95 transition-transform',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  )
})
